import styled from "styled-components";

export const DetailCardContainer = styled.div`
  border-radius: 25px;
  border: 3px solid #006f35;
  background-color: white;
  width: 100%;
  padding: 10px;
  height: 180px;
  z-index: 2;
`;

export const DetailCardCircle = styled.div`
  display: flex;
  align-items: center;
  margin: auto;
  margin-top: -50px;
  justify-content: center;
  border: 3px solid #006f35;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  background-color: white;
`;

export const DetailCardDescription = styled.div`
  color: ${({ theme, emboss }) => {
    if (emboss) {
      return "#FFFFFF;";
    }
    return theme.colors.green;
  }};
  margin-top: 20px;
  font: normal normal bold 12px/11px Open Sans;
  letter-spacing: 0.74px;
  line-height: 1.08em;
  text-align: center;
  margin-bottom: 20px;
`;
